document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll(".exercise-accordion");
    accordions.forEach(accordion => {
        accordion.addEventListener("click", function() {
            this.classList.toggle("active");
            const description = this.parentElement.nextElementSibling;
            const indicator = this.querySelector(".exercise-accordion-indicator");
            if (description.style.maxHeight) {
                description.style.maxHeight = null;
                indicator.textContent = "+";
            } else {
                description.style.maxHeight = description.scrollHeight + "px";
                indicator.textContent = "-";
            }
        });
    });
});